module.exports = __webpack_public_path__ + "media/honey-icons/icon-bathroom-a17c7b36.svg";